import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PixelPerfectGrid',
  setup(__props) {

const isVisible = computed<boolean>(() => {
  return process.env.VUE_APP_DEBUG === 'true';
})

const columns = ref<number>(20)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["PixelPerfectGrid", { visible: isVisible.value }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "Column",
        key: i
      }))
    }), 128))
  ], 2))
}
}

})